<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="400px")
    v-card
      v-card-title.pb-0.mb-0.px-5.white.text-center.align-center
        v-row(no-gutters)
          v-col.text-center
            h6.my-4.text-center Change phone number for sign in
      v-card-text.pa-0
        v-form.pa-4(ref="form")
          v-col.pb-0(cols="12")
            p.mb-3.label.basic600--text.text-uppercase Current Phone Number
            v-text-field.s1.basic800--text( solo flat background-color="basic200"    height="40" v-model="currentPhone" label="Current phone number" disabled outlined dense)
          v-col.py-0(cols="12")
            p.mb-3.label.basic600--text.text-uppercase New Phone Number
            v-text-field.s1.basic800--text(solo flat background-color="basic200"    height="40" v-model="form.auth_phone" label="New phone number" :rules="rules.auth_phone" outlined dense)
            template(v-slot:label)
                  .p1.basic600--text +60
          v-col.py-0.mb-n5.mt-n3(cols="12")
            v-row
              v-col.grow.pr-0(style="margin-right:-2px")
                p.mb-3.label.basic600--text.text-uppercase TAC Number
                v-text-field(solo flat background-color="basic200"    height="40" v-model="form.otp" outlined dense label="TAC number" :rules="rules.otp" style="border-top-right-radius:0px; border-bottom-right-radius:0px")
                template(v-slot:label)
                  .p1.basic600--text 6 digit TAC Number
              v-col.shrink.pl-0
                p.mb-3.label.white--text.text-uppercase New 
                v-btn.white--text.button-AA-medium.info500(:disabled="otpTimer > 0" @click="requestOTP" height=40 depressed style="border-top-left-radius:0px; border-bottom-left-radius:0px;") {{ otpTimer <= 0 ? 'Request' : `Request (${otpTimer})` }}
        v-divider.mb-4
        v-card-actions
          v-spacer
          v-btn.button-AA-tiny(color='grey' :loading="loading" text @click='closeModal')
            | Cancel
          v-btn.white--text.button-AA-medium.info500(color='info500' :loading="loading" depressed height=32 @click="changePhone")
            | Save
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'ChangePhone',
  props: ['showModal'],
  data: () => ({
    loading: false,
    currentPhone: '',
    form: {
      auth_phone: '',
      otp: '',
    },
    otpTimer: 0,
    rules: {
      auth_phone: [
        v => !!v || 'New phone number is required'
      ],
      otp: [
        v => !!v || 'TAC is required'
      ],
    }
  }),
  computed: {
    ...mapState('user', ['user'])
  },
  watch: {
    showModal (val) {
      this.$emit('update:showModal', val)
      if (val) {
        this.$refs.form.reset()
      }
    },
    user: {
      deep: true,
      handler (val) {
        this.currentPhone = val.auth_phone
      }
    }
  },
  mounted () {
    this.currentPhone = this.user.auth_phone
  },
  methods: {
    ...mapActions(['showMessage']),
    requestOTP () {
      if (!this.form.auth_phone) {
        this.showMessage(['error', this.$t('error_message.enter_new_phone')])
        return
      }
      this.$axios.get(`/users/check_phone/?phone=${encodeURIComponent(this.form.auth_phone)}`)
        .then(resp => {
          if (resp.data.available) {
            this.$axios.post('/users/request_otp/', { phone: this.form.auth_phone })
                .then(() => {
                  this.showMessage(['info', this.$t('info_message.tac_sent_to', { text: this.form.auth_phone })])
                  this.otpTimer = 30
                  const timer = setInterval(() => {
                    this.otpTimer--
                    if (this.otpTimer <= 0) {
                      clearInterval(timer)
                    }
                  }, 1000)
                })
                .catch(() => {
                  this.showMessage(['error', this.$t('error_message.unable_to_send_tac')])
                })
          } else {
            this.showMessage(['error', `${this.form.auth_phone} is already tied to different account`])
          }
        })
        .catch(() => {})
    },
    changePhone () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true
      this.$axios.patch(`/users/${this.user.id}/`, this.form)
        .then(resp => {
          this.$store.commit('user/setUser', resp.data)
          this.showMessage(['success', this.$t('success_message.phone_successfully_updated')])
          this.closeModal()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.invalid_tac_number')])
        })
        .finally(() => {
          this.loading = false
        })
    },
    closeModal () {
      this.$emit('update:showModal', false)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>